<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户应收质押登记详情'}]"/>
    <div>
      <pledge-detail-component :data="detailData" :contractData="contractData" />
    </div>
    <button-back></button-back>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import ButtonBack from '../../../components/ButtonBack'
  import PledgeDetailComponent from '../../components/PledgeDetailComponent'

  export default {
    name: "ServerAdminPledgeDetail",
    data() {
      return {
        detailData: {},
        contractData: {}
      }
    },
    mounted() {
      this.getCustomerPledgeDetail()
    },
    components: {
      ButtonBack,
      PledgeDetailComponent
    },
    computed: {
      filterOption: function() {
        let filterOption = {}
        Object.entries(this.$route.query).forEach(item=>{
          let[key, value] = item
          filterOption[key] = value
        })
        return filterOption
      }
    },
    methods: {
      getCustomerPledgeDetail: function () {
        xhr.getCustomerPledgeDetail(Object.assign(this.filterOption,{}), res=>{
          try{
            if(res.data.status == 'success') {
              this.detailData = res.data.data
              this.detailData.invoices = this.detailData.invoices.filter(item=>item['pi__invoiceId'])
              this.getCustomerContractDetail(this.detailData.pl__contractId)
            }
          }catch(e){}
        })
      },
      getCustomerContractDetail: function ( contractId ) {
        xhr.getCustomerContractDetail(
          {
            'ct.contractId' : contractId
          },
          res=>{
            try {
              if(res.data.status ==  'success') {
                this.contractData = res.data.data
              }
            }
            catch (e) {

            }
          }
        )
      },
      handleClick: function () {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/PledgeDetail.vue